/*import axios from "axios";
import {getServerURL} from './config';

const clienteAxios = axios.create({baseURL: getServerURL()});

export default clienteAxios;*/

import axios from "axios";
import { getServerURL } from "./config";

//Naquina Desarrollo
const clienteAxios = axios.create({
    baseURL: getServerURL(),
    //timeout:120000,
    timeout:360000,
    headers: {
        'Content-Type': 'application/json'
    }
});

clienteAxios.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        
        if(token) config.headers['Authorization'] = `Bearer ${token}`
        if (userTimeZone) config.headers['X-Timezone'] = userTimeZone; // Custom header
        return config;
    },
    (error) => {
        console.log("error sending token in the request");
        console.log(error);
        return Promise.reject(error);
    }
)

clienteAxios.interceptors.response.use(
    (response) => response,
    (error) => {
        const msg = error.response?.data?.msg;
        if (error.response?.status === 401 && (msg === 'jwt expired' || msg === 'password changed' || msg === 'user disabled')) {
            localStorage.removeItem('token');
            window.location.replace('/login');
        }
        return Promise.reject(error);
    }
)

//Para que otro pueda acceder es http://192.0.99.131:19006

export default clienteAxios;